import { useMutation } from 'react-query';
import { register } from 'src/models/user';
import { postInstructor } from 'src/services/instructors';
import { postStudent } from 'src/services/students';

export default function AddStudent() {
  return useMutation((data: register) => postStudent(data));
}
